import script from "./PedalSelectionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PedalSelectionView.vue?vue&type=script&setup=true&lang=ts"

import "./PedalSelectionView.vue?vue&type=style&index=0&id=5ab0c1c0&lang=scss"

const __exports__ = script;

export default __exports__